import { FC } from 'react';

import { useSetRecoilState } from 'recoil';

import { AccountDetailType } from '@shared/api/needAccount/needAccount.interface';
import { Button } from '@shared/components/Button';
import { simpleOpenAtomFamily } from '@shared/state/atom';
import { useId } from 'react-id-generator';

import { SellerAccountDetailModal } from './SellerAccountDetailModal';

interface Props {
  year: number;
  month: number;
  type?: AccountDetailType;
}

export const SellerAccountDetailModalButton: FC<Props> =
  function SellerAccountDetailModalButton({
    year,
    month,
    type = 'need-account',
  }: Props) {
    const [id] = useId(1, 'sellerAccoundDetailModalButton');

    const openId = `${id}`;

    const setOpen = useSetRecoilState(simpleOpenAtomFamily(openId));
    return (
      <div>
        <Button
          onClick={() => {
            setOpen(true);
          }}
        >
          상세보기
        </Button>
        <SellerAccountDetailModal
          openId={openId}
          year={year}
          month={month}
          type={type}
        />
      </div>
    );
  };
